import React from 'react';

const MinusFilledIcon = ({ colour = '#E4AB01', className }) => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <circle cx="7" cy="7" r="7" fill={colour} />
            <rect x="3.5" y="6.125" width="7" height="1.75" rx="0.875" fill="white" />
        </svg>
    );
};

export default MinusFilledIcon;
